import type { Personel } from '@/features/hr/personel/types'
import type { VariableDef } from '../types'

export function sampleValuesForPersonel(person?: Personel, variables: VariableDef[] = []): Record<string, string> {
  const fromVars = Object.fromEntries(variables.map((v) => [v.key, v.sample ?? '']))
  if (!person) return fromVars
  return {
    ...fromVars,
    'personel.ad_soyad': person.ad,
    'personel.eposta': person.email,
    'personel.telefon': person.telefon,
    'personel.departman': person.departman,
    'personel.pozisyon': person.pozisyon,
    'personel.ise_giris_tarihi': person.ise_giris,
    'personel.sicil': person.sicil,
    'personel.egitim': person.egitim,
    'personel.yonetici': person.yonetici,
    'personel.lokasyon': person.lokasyon,
    'personel.dogum_tarihi': person.dogum,
    ad_soyad: person.ad,
    eposta: person.email,
    telefon: person.telefon,
    departman: person.departman,
    pozisyon: person.pozisyon,
  }
}
